import {of} from 'rxjs';
import {map, flatMap, catchError, filter} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';
import * as API from './api';

const fetchGroupChartData = action$ =>
    action$.pipe(
        ofType(Actions.fetchGroupChartData.type),
        /**
         * FBS-5991: We were dispatching this action with an empty array of group IDs in some cases where the request for groups
         * were in-flight. I've patched the place that dispatched it, but I'm introducing this as a fallback in case
         * the patched code is changed or refactored and we end up in the same situation.
         *
         * The API returns `[]` if the set of group IDs is empty, which breaks the frontend.
         */
        filter(({payload}: ReturnType<typeof Actions.fetchGroupChartData.action>) => payload.groupIds.length > 0),
        flatMap(({payload}: ReturnType<typeof Actions.fetchGroupChartData.action>) =>
            API.fetchGroupChartData(payload.groupIds).pipe(
                map(result => Actions.fetchGroupChartDataSuccess.action(result)),
                catchError(e => of(Actions.fetchGroupChartDataFailed.action(e))),
            ),
        ),
    );

const fetchTagChartData = action$ =>
    action$.pipe(
        ofType(Actions.fetchTagChartData.type),
        flatMap(({payload}: ReturnType<typeof Actions.fetchTagChartData.action>) =>
            API.fetchTagChartData(payload.tagId).pipe(
                map(result => Actions.fetchTagChartDataSuccess.action(result)),
                catchError(e => of(Actions.fetchTagChartDataFailed.action(e))),
            ),
        ),
    );

export default combineEpics(fetchGroupChartData, fetchTagChartData);
